// utils.ts

/**
 * Remove the "data: " prefix from the streamed string if exists
 */
export const removeDataPrefix = (str: string): string => {
  if (str.startsWith("data: ")) {
    return str.substring(6);
  }
  return str;
};

/**
 * Process streamed raw data line to JSON object safely
 */
export const processRawData = (rawData: string): any | null => {
  const jsonDataString = removeDataPrefix(rawData);
  try {
    return JSON.parse(jsonDataString);
  } catch {
    return null;
  }
};
